import { useDatabaseContent } from '@databases/database-state';
import { messages } from '@databases/intl/messages';
import usePanel from '@databases/panel/usePanel';
import { defaultStoreUtils } from '@databases/redux';
import { selectEntrySingle } from '@databases/redux/cellSelections/actions';
import { currentSnackbarState } from '@databases/snackbar/snackbar';
import {
  getDatabaseEntryOptional,
  isBrokenDatabase,
} from '@databases/utils/database/utils';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl-next';

export const useEntryPanel = ({ contentId }: { contentId: string }) => {
  const { entryId } = useDatabaseContent();
  const [isLoaded, setIsLoaded] = useState(false);
  const dispatch = defaultStoreUtils.useDispatch();

  const { showPanel } = usePanel();

  const intl = useIntl();
  const { formatMessage } = intl;

  const entryExists = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, { contentId });
    const entry = entryId
      ? database &&
        !isBrokenDatabase(database) &&
        getDatabaseEntryOptional(database, entryId)
      : null;

    return !!entry;
  });

  useEffect(() => {
    if (!isLoaded && entryId && entryExists) {
      showPanel('EntryViewPanel', {
        entryId,
      });

      dispatch(
        selectEntrySingle({
          contentId,
          entryId,
        })
      );
    } else if (entryId && !entryExists) {
      void currentSnackbarState.setMessage(
        formatMessage(messages['snackbar-error.deleted-linked-entry']),
        {
          id: 'linked-database-entry-deleted',
          type: 'info',
          showCloseButton: true,
        }
      );
    }
    setIsLoaded(true);
  }, [contentId, dispatch, entryExists, entryId, formatMessage, isLoaded, showPanel]);
};
